export type UseSplashScreenProps = {
  enabled: boolean;
  site: string;
  splashScreens: Array<{ fullName: string; name: string; url: string; }>;
}

export function useSplashScreen({ enabled, site, splashScreens }: UseSplashScreenProps) {
  if (!enabled) {
    return <></>
  }

  const splashScreensRegister = [
    {
      "name": "iphone5.png",
      "media": "(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "iphone6.png",
      "media": "(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "iphoneplus.png",
      "media": "(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "iphonex.png",
      "media": "(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "iphonexr.png",
      "media": "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "iphonexsmax.png",
      "media": "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "ipad.png",
      "media": "(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "ipadpro1.png",
      "media": "(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "ipadpro3.png",
      "media": "(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    },
    {
      "name": "ipadpro2.png",
      "media": "(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
      "rel": "apple-touch-startup-image"
    }
  ]

  const registeredScreens: Array<any> = splashScreens.map((i) => {
    const selected = splashScreensRegister.find((s) => s.name === i.fullName)
    if (selected && selected.name) {
      return { ...i, ...selected }
    } else {
      return { ...i }
    }
  })

  const elements = registeredScreens.map((i) => (
    <link
      key={`splashScreen-${i.name}`}
      href={i.url}
      media={i.media}
      rel={i.rel}
    />
  ))

  return elements
}